import React, { useEffect, useState } from 'react'
import ScrollContainer from 'react-indiana-drag-scroll'
import API from '../../services/api';
import NoDataFound from '../../shared/NoDataFound'
import config from '../../config';

function FinanceDashboard() {
    const [revenue, setRevenue] = useState([])
    const [impressions, setImpressions] = useState([])
    const [agingReport, setAgingReport] = useState([])
    const [customerWise, setCustomerWise] = useState([])
    const [agingCounts, setAgingCounts] = useState()
    const [CusomterwiseCounts, setCusomterwiseCounts] = useState()
    const [currentAgingPage, setCurrentAgingPage] = useState(0);
    const [currentCustomerwisePage, setCurrentCustomerwisePage] = useState(0);

    const fetchImpressions = async () => {
       try {
            let res = await API({
                url: "/finance_panel/impressions",
                method: "POST",
                responseType: "json",
                data: {},
            });
            if (res.code === 200) {
                setImpressions(res.data);
            }
        } catch (error) {
            console.error(error);
        }
    }
    const fetchRevenue = async() =>{
        try {
            let res = await API({
                url: "/finance_panel/revenue",
                method: "POST",
                responseType: "json",
                data: {},
            });
            if (res.code === 200) {
                setRevenue(res.data);
            }
        } catch (error) {
            console.error(error);
        }
    }
    const fetchAgingReport = async(page) =>{
        try {
            let res = await API({
                url:'finance_panel/aging-reports',
                method:'POST',
                responseType:'json',
                data:{
                    search:'',
                    limit:config.PER_PAGE,
                    offset:page
                }
            });
            if (res.code === 200) {
                setAgingReport([...agingReport, ...res.data?.data]);
                setAgingCounts(res.data?.totalCounts);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const fetchCustomerwiseReport = async(page) => {
        try {
            let res = await API({
                url:'/finance_panel/customerwise-sales',
                method:'POST',
                responseType:'json',
                data:{
                    search:'',
                    limit: config.PER_PAGE,
                    offset:page
                }
            })
          
            if (res.code === 200) {
                setCustomerWise([...customerWise, ...res.data?.data]);
                setCusomterwiseCounts(res.data?.totalCounts);
            }
        } catch (error) {
            console.error(error);
        }
    }
    useEffect(() => {
        fetchRevenue();
        fetchImpressions();
        fetchAgingReport(currentAgingPage);
        fetchCustomerwiseReport(currentCustomerwisePage);
    }, [])
    function getValue(monthId = 'previous_month',type='', data) {
        // console.log(revenue, 'revenue')
        if(data.length < 0) {
            return '';
        }
        // Find the object with the given _id
        const monthData = data.find(month => month._id === monthId);
      
        // If the month is not found, return an error message
        if (!monthData) {
        //   console.error(`Month with _id ${monthId} not found.`);
          return '0'
        }
      
        // Return the value of the provided type for the found month
        return monthData[type] !== undefined ? monthData[type] : `0`;
      }
    function daysBetween(timestamp) {
        // Convert 10-digit timestamp to milliseconds and create a Date object
        const startDate = new Date(timestamp * 1000);
        
        // Get today's date
        const endDate = new Date();
        
        // Check if startDate is valid
        if (isNaN(startDate.getTime())) {
            throw new Error("Invalid timestamp");
        }
    
        const millisecondsPerDay = 86400000; // 24 * 60 * 60 * 1000
        
        // Calculate the difference in days
        return Math.floor((endDate - startDate) / millisecondsPerDay);
    }




  return (
    <>
        <div>
            <h3>Dashboard</h3>

            <div className='glimpse-view flex-wrap'>
                <div className='revenue-stats'>
                    <h6>Revenue</h6>
                    <div className='statsHead'>
                        <label>&nbsp;</label>
                        <label>Last Month</label>
                        <label>This Month</label>
                    </div>
                    <div className='statsRow'>
                        <label>Local</label>
                        <label>{getValue('previous_month','local', revenue)}</label>
                        <label>{getValue('current_month','local', revenue)}</label>
                    </div>
                    <div className='statsRow'>
                        <label>National</label>
                        <label>{getValue('previous_month','national', revenue)}</label>
                        <label>{getValue('current_month','national', revenue)}</label>
                    </div>
                    <div className='statsRow'>
                        <label>Alpha</label>
                        <label>{getValue('previous_month','alpha', revenue)}</label>
                        <label>{getValue('current_month','alpha', revenue)}</label>
                    </div>
                    <div className='statsRow'>
                        <label>Network</label>
                        <label>&nbsp;</label>
                        <label>&nbsp;</label>
                    </div>
                </div>
                <div className='revenue-stats impBg'>
                    <h6>Impressions</h6>
                    <div className='statsHead'>
                        <label>&nbsp;</label>
                        <label>Last Month</label>
                        <label>This Month</label>
                    </div>
                    <div className='statsRow'>
                        <label>Local</label>
                        <label>{parseInt(getValue('previous_month','local', impressions))}</label>
                        <label>{parseInt(getValue('current_month','local', impressions))}</label>
                    </div>
                    <div className='statsRow'>
                        <label>National</label>
                        <label>{parseInt(getValue('previous_month','national', impressions))}</label>
                        <label>{parseInt(getValue('current_month','national', impressions))}</label>
                    </div>
                    <div className='statsRow'>
                        <label>Alpha</label>
                        <label>{parseInt(getValue('previous_month','alpha', impressions))}</label>
                        <label>{parseInt(getValue('current_month','alpha', impressions))}</label>
                    </div>
                    <div className='statsRow'>
                        <label>Network</label>
                        <label>{parseInt(getValue('previous_month','network', impressions))}</label>
                        <label>{parseInt(getValue('current_month','network', impressions))}</label>
                    </div>
                </div>
            </div>

        </div>
        <div className='d-flex justify-around flex-wrap mt-4'>
            <div className='box-shadow p-1  max-h-96 relative lg:w-1/2 sm:w-full'>
                <h5>Top 10 Aging Reports</h5>
                <table className="table table-bordered my-2 overflow-scroll">
                    <thead>
                        <tr>
                            <th>Customer</th>
                            <th>Not at Due</th>
                            <th>30</th>
                            <th>90</th>
                            <th>180</th>
                            <th>{">180"}</th>
                        </tr>
                    </thead>
                    
                        {agingReport?.length > 0 ? <tbody> {agingReport?.map((item, index) => {
                        
                          const days = item.due_amount <= 0 ? -1 : daysBetween(item.credited_period);
                          let due_amount = item.due_amount <= 0 ? 0 :   item.due_amount
                            return (
                                <tr key={index}>
                                    <td>{item?.company_name}</td>
                                    <td>{days < 0 ? due_amount : ""}</td>
                                    <td>{0<= days && days <= 30 ? due_amount : ''}</td>
                                  <td>{days >= 31 && days <= 90 ? due_amount : ''}</td>
                                  <td>{days >= 91 && days <= 180 ? due_amount : ''}</td>
                                  <td>{days > 180 ? due_amount : ''}</td>
                                </tr>
                            )
                        })}</tbody> : <NoDataFound colspan={5}/>}
                    
                        </table>
                {agingCounts >  agingReport.length ? <div className='d-flex justify-end sticky bottom-0'>
                    <button className=' text-xs cursor-pointer text-blue-500 border-none bg-white' onClick={() => {fetchAgingReport(currentAgingPage + 1); setCurrentAgingPage(currentAgingPage + 1)}}>
                        more
                    </button>
                </div> : null}
            </div>
            <div className='box-shadow p-1  max-h-96 relative lg:w-1/2 ls:w-full'>
                <h5>Top 10 Cusomterwise Sales Reports</h5>
                <table className="table table-bordered my-2 overflow-scroll">
                    <thead>
                        <tr>
                            <th>Customer</th>
                            <th>Payment</th>
                            <th>Due</th>
                        </tr>
                    </thead>
                    
                        {customerWise?.length > 0 ? <tbody> {customerWise?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>{item?.company_name}</td>
                                    <td>{item.total_payment}</td>
                            <td>{item.due_amount}</td>
                                </tr>
                            )
                        })}</tbody> : <NoDataFound colspan={5}/>}
                    
                        </table>
                {CusomterwiseCounts >  customerWise.length ? <div className='d-flex justify-end sticky bottom-0'>
                    <button className=' text-xs text-blue-500 border-none bg-white cursor-pointer' onClick={() => {fetchCustomerwiseReport(currentCustomerwisePage + 1); setCurrentCustomerwisePage(currentCustomerwisePage + 1)}}>
                        more
                    </button>
                </div> : null}
            </div>
        </div>
    </>
  )
}

export default FinanceDashboard